import SustainabilityConstants from '@/components/sustainability/SustainabilityConstants'
import WalkthroughAttachmentService from '@/services/WalkthroughAttachmentService'

export default {
  data() {
    return {
      supportedImageExtensions: 'jpg,jpeg,png,gif,bmp',
      fileListSetupComplete: false,
      maxFileSize: undefined,
      acceptedExtensions: '',
    }
  },
  mounted() {
    const maxFileSizeInMb = localStorage.getItem('maxUploadSizeInMb')
    if (maxFileSizeInMb) {
      this.maxFileSize = maxFileSizeInMb * SustainabilityConstants.ONE_MB_IN_BYTES
    }
    const fileExtensionWhiteList = localStorage.getItem('fileExtensionWhiteList')
    if (
      fileExtensionWhiteList &&
      fileExtensionWhiteList !== SustainabilityConstants.WILDCARD_FILE_EXTENSION
    ) {
      // EHS expects file extensions to be provided in a comma separated list
      // with a . at the start of each extension while FileList
      // component will add a . on it's own if extensions are passed as a one string,
      // therefore we need to ensure we pass a list with a . at the start.
      //
      // Also, E360 accepts wildcards like '.doc*', FileList doesn't so at least accept '*.doc'
      this.acceptedExtensions = fileExtensionWhiteList
        .split(',')
        .map((fileType) => {
          if (fileType.charAt(0) === '.') {
            fileType = fileType.substring(1)
          }
          if (fileType.charAt(fileType.length - 1) === '*') {
            fileType = fileType.substring(0, fileType.length - 1)
          }
          return fileType
        })
        .map((fileType) => `.${fileType.trim().toLowerCase()}`)
    }
    this.fileListSetupComplete = true
  },
  methods: {
    getThumbnailUrl(file) {
      return WalkthroughAttachmentService.getThumbnailUrl(file)
    },
  },
}
